import { z } from "zod"

export type MagentoAttempt = {
  entityId: string
  incrementId: string
  status: string
  createdAt: string
  grandTotal: number
  observedAt: string
}

export type MagentoAttemptDecision = {
  version: number
  entityId: string | null
  previousEntityId: string | null
  actor: string
  reason: string
  selectedAt: string
  candidateSet: string
  candidates: MagentoAttempt[]
}

export type MagentoAttemptPreview = {
  expectedEntityId: string | null
  expectedVersion: number
  candidateSet: string
  candidates: MagentoAttempt[]
  selectableEntityIds: string[]
  manualEntityId: string | null
}

export const selectMagentoAttemptBodySchema = z
  .object({
    entityId: z.string().min(1).max(100).nullable(),
    reason: z.string().trim().min(1).max(2000),
    expectedEntityId: z.string().min(1).max(100).nullable(),
    expectedVersion: z.number().int().nonnegative(),
    candidateSet: z.string().regex(/^[a-f0-9]{64}$/),
  })
  .strict()

export type SelectMagentoAttemptBody = z.infer<typeof selectMagentoAttemptBodySchema>
